export const Template = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="6" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="5" y="15" width="6" height="12" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="15" y="15" width="12" height="12" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
